import { Box, BoxProps, Button, Image, Text } from "@chakra-ui/react";
import { ArrowLeft } from "~/images/svgs";
import { useLegContext } from "..";

export const EastToWestToggle = ({ ...boxProps }: BoxProps) => {
  const { isEast, toggleDirection } = useLegContext();
  const compassImage = isEast ? "/eastWestCompass.png" : "/westEastCompass.png";
  return (
    <Box
      bgColor="blue.100"
      padding={{ base: "16px 24px" }}
      maxW={{ base: "90vw", md: "265px" }}
      borderRadius={{ base: 10 }}
      display="flex"
      justifyContent="space-evenly"
      alignItems={"center"}
      onClick={toggleDirection}
      border="2px solid"
      {...boxProps}
    >
      <Image h={30} w={30} src={compassImage} alt="compass" />
      <Box
        display="flex"
        alignItems={"center"}
        w="144px"
        justifyContent="space-between"
      >
        <Button p={0} colorScheme="transparent">
          <Text
            fontSize={{ base: "xl" }}
            color={!isEast ? "gray.500" : "gray.900"}
            sx={{ _hover: { textDecoration: "underline" } }}
          >
            West
          </Text>
        </Button>

        <ArrowLeft
          boxSize={30}
          transform={`rotate(${isEast ? "0" : "180"}deg)`}
          transition="transform"
          transitionDuration={"0.25s"}
        />
        <Button p={0} colorScheme="transparent">
          <Text
            fontSize={{ base: "xl" }}
            color={isEast ? "gray.500" : "gray.900"}
            sx={{ _hover: { textDecoration: "underline" } }}
          >
            East
          </Text>
        </Button>
      </Box>
    </Box>
  );
};
